import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    main: {
      backgroundColor: palette.background.paper,
      flex: 1,
      overflow: 'auto',
    },
  }),
)
